module.exports = __webpack_public_path__ + "static/media/tablet.f75a47cf.svg";